import { Routes } from '@angular/router';
import { ClosureComponent } from '@app/features/closure/closure.component';

export const APP_BROWSER_ROUTES = [
  // { path: '', loadChildren: () => import('./features/box-deals/box-deals.routes').then((r) => r.BOXDEALS_ROUTES) },
  // {
  //   path: SalesArticleRoute,
  //   loadChildren: () => import('./features/sales-article/sales-article.routes').then((m) => m.SALES_ARTICLES_ROUTES)
  // },
  // {
  //   path: AuthRoute,
  //   loadChildren: () => import('./features/authentication/authentication.routes').then((r) => r.AUTHENTICATION_ROUTES)
  // },
  // {
  //   path: AccountRoute,
  //   loadChildren: () => import('./features/account/account.routes').then((r) => r.ACCOUNT_ROUTES)
  // },
  // { path: BlogRoute, loadChildren: () => import('./features/blog/blog.routes').then((r) => r.BLOG_ROUTES) },
  // { path: SearchRoute, loadChildren: () => import('./features/search/search.routes').then((r) => r.SEARCH_ROUTES) },
  // {
  //   path: CheckoutRoute,
  //   providers: [
  //     provideStates([CheckoutState]),
  //     importProvidersFrom(
  //       PointsOfInterestModule.forFeature({
  //         urlPath: '/api/geo/get-nearest-service-point',
  //         types: '31',
  //         limit: 20
  //       })
  //     )
  //   ],
  //   loadChildren: () => import('./features/checkout/checkout.routes').then((r) => r.Routes)
  // },
  // {
  //   path: 'collections',
  //   providers: [provideStates([CollectionsState])],
  //   loadChildren: () => import('./features/collections/collections.routes').then((r) => r.Routes)
  // },
  // { path: CustomerServiceTermsSubRoute, redirectTo: CustomerServiceTermsRoute, pathMatch: 'full' },
  // { path: CustomerServiceAboutUsSubRoute, redirectTo: CustomerServiceAboutUsRoute, pathMatch: 'full' },
  // { path: CustomerServicePrivacySubRoute, redirectTo: CustomerServicePrivacyRoute, pathMatch: 'full' },
  // { path: CustomerServiceRetourSubRoute, redirectTo: CustomerServiceRetourRoute, pathMatch: 'full' },
  // { path: CustomerServiceCookieSubRoute, redirectTo: CustomerServiceCookieRoute, pathMatch: 'full' },
  { path: 'sluiting', component: ClosureComponent },
  { path: '**', redirectTo: 'sluiting', pathMatch: 'full' }
] as Routes;
